<div>
  <div class="header">
    <div>
      <div class="d-flex align-items-md-center justify-content-between mx-2 mx-md-4 mt-1 mt-md-2">
        <a (click)="scrollToElement(pagetop)" class="navbar-brand pb-2 cursor-pointer">
          <img src="assets/img/learning.png" alt="logo" class="nav-image" />
        </a>
        <a  class="nav-link navli cursor-pointer font-weight-bolder" (click)="redirectToMainWebsite()">Back To
          Main Website
          <img src="../../../../assets/img/arrow-right.svg" /></a>
      </div>
      <div #pagetop>
        <div class="container-xxl d-flex align-items-center justify-content-center">
          <div class="">
            <div class="flex-grow-1 d-sm-flex d-none">
              <div class="text-lg-start pt-40" [class]="{ 'd-none': showForms }">
                <button class="btn btn-secondary btn-md d-sm-none d-flex mt-2" style="width: fit-content" type="button"
                  (click)="showForms = true">
                  Sign In
                  <i data-feather="arrow-right" class="pl-2"></i>
                </button>
              </div>
            </div>
            <div class="row d-sm-flex" [class]="{ 'd-flex': showForms }">
              <div class="col-12">
                <div class="card loginformwidth" [ngClass]="{'signUpFormWidth': register}">
                  <div class="p-1">
                    <h4 class="p-0 pt-1 text-center text-black font-weight-bolder text-capitalize"
                      *ngIf="(register) && !loginUserChecked && !isMawinguRedirect">
                      Create your account
                    </h4>
                    <h5 *ngIf="register && !isMawinguRedirect" class="text-center text-black mb-0">
                      Simply fill out the form below to get started
                    </h5>
                  </div>

                  <!-- login form -->
                  <div class=" login-form mt-0 pt-0 mx-2" [ngClass]="loginClasses" *ngIf="!showRegisterMawingu">
                    <section *ngIf="login || forgot || forgotUsername">
                      <ng-container *ngIf="!loginUserChecked && !userAccountTypeSelected">
                         <div class="login-header d-flex align-items-center flex-column"
                          *ngIf="login && !loginUserChecked && !showTeacherForgotUsername">
                          <!-- show this section when a user account has not been selected yet -->
                            <h5 class="text-black text-center mb-md-2">Welcome To Zeraki Learning</h5>
                            <div *ngIf="isMawinguRedirect" class="text-center mb-2">
                              <p class="text-black">You've been redirected from <b>Mawingu</b> to access premium learning resources and tools
                                designed for Kenyan students.</p>
                              <p class="text-black mt-md-2">Enjoy a <b> 30% discount off your subscription </b>as our welcome gift!!</p>
                            </div>
                            <img src="../../../../assets/img/Group 40086.png" alt="bee-icon" class="bee-icon-img">
                          <!-- </div> -->
                          
                         <p class="text-black text-center mt-md-3 font-weight-bolder">
                           {{
                             selectedRole === 'Teacher' ? 'Teacher Account' :
                             selectedRole === 'Parent' ? 'Parent Account' :
                             (userAccountTypeSelected ? 'Student Account' : 'What&rsquo;s the plan today?')
                           }}
                         </p>
                        </div>
                        <div *ngIf="userAccountTypeSelected && !showForgotUsername && !showTeacherForgotUsername" class="text-left mb-2 allleft" style="font-size: 0.95em; color: #666; text-align: left !important;">
                          <ng-container *ngIf="selectedRole === 'Teacher'; else notTeacherSubtext">
                            Teachers in schools with Zeraki Analytics can login here. We currently can't support Non Zeraki school teachers.
                          </ng-container>
                          <ng-template #notTeacherSubtext>
                            <ng-container *ngIf="selectedRole === 'Parent'; else studentSubtext">
                              Please use your phone number to log in as a parent. If you have trouble, contact support.
                            </ng-container>
                            <ng-template #studentSubtext>
                              Does your school have a <span class="text-primary">Zeraki School Code? </span>Check first using <b>forgot username</b>. If not use <span class="text-primary">Phone Number</span>
                            </ng-template>
                          </ng-template>
                        </div>

                        <!-- radio -->
                        <div *ngIf="!userAccountTypeSelected" class="radio-user-list">
                          <div class="role-card mt-2 cursor-pointer rounded p-1" [ngClass]="[
                            (last ? 'mb-1' : 'mb-2'), 
                            (selectedRole === role ? 'role-card-selected' : '')
                          ]" *ngFor="let role of userRoles; let last = last" (click)="switchLabels(role)">
                        
                            <div style="display: flex; align-items: flex-start; gap: 12px;">
                        
                              <input type="radio" name="roleOptions" [id]="'roleOption' + role" [value]="role" [checked]="selectedRole === role"
                                 style="
                                cursor: pointer; 
                                width: 18px; 
                                height: 18px; 
                                flex-shrink: 0;
                                margin-top: 2px;
                              " />
                        
                              <div style="display: flex; flex-direction: column;">
                        
                                <!-- Role Name -->
                                <div class="font-weight-bolder text-black" 
                                  style="font-size: 16px; line-height: 1.2; margin-bottom: 4px;">
                                      {{ isMawinguRedirect && role === 'Student' ? 'General Learner Account' : role + ' Account' }}
                                </div>
                                <!-- Teacher subtitle for mawingu -->
                                <small *ngIf="isMawinguRedirect && role === 'Teacher'" 
                                    class="text-muted" style="font-style: italic;   margin-bottom: 8px;font-size: 14px; color: #5D5E5D ! important;">
                                    For teachers in schools using Zeraki Analytics
                                </small>
                                <!-- Description -->
                                <small class="font-small-4 font-weight-bolder"  style="line-height: 1.3; font-family: 'Inter', sans-serif !important;">
                                  <ng-container [ngSwitch]="role">
                                    <span *ngSwitchCase="'Student'">
                                      Access Beewiz contests, Video lessons, Exam Questions and Notes
                                    </span>
                                    <span *ngSwitchCase="'Teacher'">
                                      Access Video Lessons, Upload assignments & Notes, Host student contests
                                    </span>
                                    <span *ngSwitchCase="'Parent'">
                                      Monitor and track your child's learning progress
                                    </span>
                                  </ng-container>
                                </small>
                              </div>
                            </div>
                          </div>
                          <button *ngIf="!loginUserChecked" [disabled]="loading || !selectedRole" 
                             class="btn btn-primary btn-block mb-1 mt-2" tabindex="4"
                            rippleEffect type="button" (click)="setLoginAccountSelected()">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Continue <i class="fa fa-chevron-right ml-1" aria-hidden="true"></i> 
                          </button>
                        
                        </div>
                         <!-- end -->

                      </ng-container>
                      <ng-container *ngIf="((login && userAccountTypeSelected) || (showForgotUsername || forget))">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="min-width-left">
                            <p *ngIf="userAccountTypeSelected || showForgotUsername || forgot"
                              (click)="showResetPassword ? backToLoginFromReset() : ((userAccountTypeSelected && !showForgotUsername && !forgot) ? switchUser() : changeUser('login'))"
                              class="text-center mb-0 cursor-pointer">
                              <i class="fa fa-chevron-left mr-1 text-muted" aria-hidden="true"></i>
                              <span class="text-black">{{ (userAccountTypeSelected && !showForgotUsername && !forgot && !showResetPassword) ? 'Change User' : 'Back' }}</span>
                            </p>
                          </div>
                          <button (click)="launchHelpModal(showForgotUsername ? 'forgotUsername' : 'login')" class="btn btn-sm text-black font-weight-bolder" style="border: 1px solid #DDDEDD; background: #FCFCFC">Need
                            Help <img src="../../../../assets/img/help.svg" style="height: 22px;" alt=""></button>
                        </div>
                        <ng-container *ngIf="!(showForgotUsername || forget)">
                        <p class="text-black font-medium-5 mt-md-3 font-weight-bolder">
                          {{
                          selectedRole === 'Teacher' ? 'Teacher Account' :
                          selectedRole === 'Parent' ? 'Parent Account' :
                          (isMawinguRedirect ? 'Learner Account' : 'Student Account')
                          }}
                        </p>

                          <ng-container *ngIf="selectedRole === 'Teacher'; else notTeacherSubtext">
                            Teachers in schools with Zeraki Analytics can login here. We currently can't support Non Zeraki school teachers.
                          </ng-container>
                          </ng-container>
                          <ng-template #notTeacherSubtext>
                            <ng-container *ngIf="selectedRole === 'Parent'; else studentSubtext">
                              Please use your phone number to log in as a parent. If you have trouble, contact support.
                            </ng-container>
                            <ng-template #studentSubtext>
                              Does your school have a <span class="text-primary font-weight-bolder">Zeraki School Code? </span>Check first using <b>forgot username</b>. If not use <span class="text-primary font-weight-bolder">Phone Number</span>
                            </ng-template>
                          </ng-template>
                      </ng-container>
                      <ng-container>

                      </ng-container>
                      <!-- Login Form-->
                      <app-login-form
                        *ngIf="login && userAccountTypeSelected && !showResetPassword && !showTeacherForgotUsername"
                        [selectedRole]="selectedRole"
                        [userNameText]="userNameText"
                        [userNamePlaceholder]="userNamePlaceholder"
                        [prefillUsername]="prefillUsername"
                        (usernameChange)="currentLoginUsername = $event"
                        (userCheckedChange)="loginUserChecked = $event"
                        (accountTypeDetected)="onAccountTypeDetected($event)"
                        (forgotUsernameClick)="switchForm('forgotUsername')"
                        (teacherForgotUsernameClick)="showTeacherForgotUsernameForm()"
                        (forgotPasswordClick)="onLoginFormForgotPassword($event)">
                      </app-login-form>

                      <!-- Teacher Forgot Username -->
                      <app-teacher-forgot-username
                        *ngIf="showTeacherForgotUsername && selectedRole == 'Teacher'"
                        (back)="showTeacherForgotUsername = false">
                      </app-teacher-forgot-username>
                      <!-- End Teacher Forgot Username -->

                      <!-- Student Reset Password -->
                      <app-student-reset-password
                        *ngIf="showResetPassword"
                        [checkedResetUsername]="checkedResetUsername"
                        (back)="backToLoginFromReset()">
                      </app-student-reset-password>
                      <!-- End Student Reset Password -->

                     <!-- Forgot Password -->
                      <app-forgot-password
                        *ngIf="forgot"
                        [username]="currentLoginUsername"
                        [prefilledPhoneNumber]="forgotPhoneNumber"
                        [phoneNumberReadonly]="phoneNumberReadonly"
                        (back)="switchForm('login')"
                        (passwordResetComplete)="onForgotPasswordComplete($event)">
                      </app-forgot-password>
                      <!-- End of Forgot Password -->

                      <!-- forget username form -->
                      <app-forgot-username 
                        *ngIf="showForgotUsername"
                        [isMawinguRedirect]="isMawinguRedirect" 
                        [mawinguPhoneNumber]="mawinguPhoneNumber" 
                        [getUserSubscriptionDetails]="getUserSubscriptionDetails"
                        (switchToSignUpForm)="switchForm('register')"
                        (skipMawingu)="changeUser('login')"
                        (goToRegisterEvent)="goToRegisterMawingu()"
                        >
                      </app-forgot-username>
                      
                    </section>

                    <!-- Register Form-->
                    <section *ngIf="register">
                      <app-register-form 
                         (registrationSuccess)="onRegistrationSuccess($event)">
                      </app-register-form>
                    </section>            
                      <!-- End of Register Form-->

                    <p class="text-center mt-2" *ngIf="register && !isMawinguRedirect">
                      <span>Already have an account?</span>
                      <a (click)="switchForm('login')" href="javascript:void(0)"><span>&nbsp;Sign in</span></a>
                    </p>
                    <p class="text-center sign-up align-items-center mt-1" *ngIf="login && userAccountTypeSelected && selectedRole !== 'Teacher'">
                      <span>New to our platform?</span>
                      <a (click)="isMawinguRedirect ? goToRegisterMawingu() : switchForm('register')" href="javascript:void(0)" style="text-decoration: underline;"><span>&nbsp;Create a
                      Free Account</span></a>
                    </p>
                  </div>
                  <app-register-popup
                    *ngIf="showRegisterMawingu"
                    [mawinguPhoneNumber]="mawinguPhoneNumber"
                    (closeModal)="onRegisterMawinguClosed()"
                    (registrationSuccess)="onRegisterMawinguSuccess()">
                  </app-register-popup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>